import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=b45a16ae"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=b45a16ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports